// extracted by mini-css-extract-plugin
module.exports = {"step":"styles-module--step--mHzcG","step__index":"styles-module--step__index--1YskC","step__title":"styles-module--step__title--334aU"};